import React from 'react';
// import blackShoe from "../../../assets/icons/blackshoe.svg";
// import shoeIcon from "../../../assets/icons/shoe.svg";
import { useTranslation } from 'react-i18next';
import * as moment from 'moment';
import { BiFootball } from 'react-icons/bi';
import { GiRunningShoe } from 'react-icons/gi';

const Card = ({ data }) => {
  const { t, i18n } = useTranslation();

  return (
    <div className="m-3 rounded-xl border border-slate-300 dark:border-white/20 
                 text-slate-900 dark:text-white bg-white dark:bg-bg_header_dark
                p-4 shadow-md font-inter text-sm">

      {/* Header */}
      <div className="flex items-center justify-between border-b border-dashed border-slate-500 pb-3 mb-3">
        <div className="flex items-center gap-2">
          {data.gamblingTypeId === 2 && <GiRunningShoe size={22} />}
          {data.gamblingTypeId === 1 && <BiFootball size={22} />}

          <h2 className="font-medium text-football dark:text-white">
            {data?.gamblingTypeId === 1 ? t("body") : t("maungg")}
          </h2>
        </div>

        <span
          className={`px-3 py-1 text-xs rounded-full font-bold
        ${data?.status === 'Win'
              ? 'bg-green-100 text-green-600 dark:bg-green-500/20 dark:text-green-400'
              : 'bg-red-100 text-red-600 dark:bg-red-500/20 dark:text-red-400'
            }`}
        >
          {data?.status}
        </span>
      </div>

      {/* Date */}
      <p className="text-xs text-gray-500 dark:text-gray-400 ml-6 mb-3">
        {moment(new Date(data?.createdDate)).format('DD.MM.YYYY h:mm A')}
      </p>

      {/* Info */}
      <div className="space-y-2 pl-6">
        <div className="flex justify-between">
          <span className="text-sm">{t("betAmount")}</span>
          <span className="font-bold">
            {parseInt(data?.amount).toLocaleString()}
          </span>
        </div>

        {data?.gamblingTypeId === 2 && (
          <div className="flex justify-between">
            <span className="text-sm">{t("teamCount")}</span>
            <span className="font-bold">{data?.teamCount}</span>
          </div>
        )}

        <div className="flex justify-between">
          <span className="text-sm">{t("profitAmount")}</span>
          <span
            className={`font-bold ${data?.profitAmount > 0 ? 'text-win' : 'text-gray-400'}`}
          >
            {data?.profitAmount < 0
              ? "0"
              : parseInt(data?.profitAmount).toLocaleString()}
          </span>
        </div>
      </div>
    </div>

  );
};

export default Card;
